"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickupForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ClickupForm = function (_a) {
    var iframeSrc = _a.iframeSrc, title = _a.title;
    (0, react_1.useEffect)(function () {
        // Load ClickUp forms embed script when component mounts
        var scriptSrc = "https://app-cdn.clickup.com/assets/js/forms-embed/v1.js";
        var scriptAdded = false;
        var scriptEl = document.querySelector("script[src=\"".concat(scriptSrc, "\"]"));
        if (!scriptEl) {
            scriptEl = document.createElement("script");
            scriptEl.src = scriptSrc;
            scriptEl.async = true;
            document.head.appendChild(scriptEl);
            scriptAdded = true;
        }
        // Ensure the iframe never expands beyond the viewport so it keeps its own scrollbar
        var styleId = "clickup-complaints-form-style";
        var styleEl = document.getElementById(styleId);
        var styleAdded = false;
        if (!styleEl) {
            styleEl = document.createElement("style");
            styleEl.id = styleId;
            styleEl.textContent = "\n        iframe[data-clickup-form=\"complaints\"] {\n          width: min(100%, 90vw) !important;\n          min-width: min(100%, 50vw) !important;\n          height: clamp(50vh, calc(100vh - 6rem), 95vh) !important;\n          min-height: 50vh !important;\n          max-height: calc(100vh - 4rem) !important;\n        }\n      ";
            document.head.appendChild(styleEl);
            styleAdded = true;
        }
        return function () {
            // Cleanup injected assets when component unmounts
            if (scriptAdded && scriptEl && scriptEl.parentNode) {
                scriptEl.parentNode.removeChild(scriptEl);
            }
            if (styleAdded && styleEl && styleEl.parentNode) {
                styleEl.parentNode.removeChild(styleEl);
            }
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", { className: "p-4 h-full flex flex-col", children: (0, jsx_runtime_1.jsx)("iframe", { className: "clickup-embed", src: iframeSrc, width: "100%", scrolling: "yes", "data-clickup-form": "complaints", style: {
                background: "transparent",
                border: "1px solid #ccc",
                flex: "1",
            }, title: title, onWheel: function () { } }) }));
};
exports.ClickupForm = ClickupForm;
